import React from 'react';
import { useTranslation } from 'react-i18next';
import AppIcon from '../AppIcon';
import { Tooltip } from './Tooltip';

interface AiGeneratedBadgeProps {
  visible: boolean;
  className?: string;
  /** Overrides the default hint, which speaks of editing and is wrong on a read-only surface. */
  hint?: string;
}

// Marks a field the AI filled; the caller clears it the moment the user edits that field.
const AiGeneratedBadge: React.FC<AiGeneratedBadgeProps> = ({ visible, className, hint }) => {
  const { t } = useTranslation();
  if (!visible) return null;

  return (
    <Tooltip content={hint ?? t('ai.generatedHint')}>
      {/* Not a tab stop, so a popover that holds it never opens the hint on its own; screen readers get it as text. */}
      <span
        className={`inline-flex items-center gap-1 rounded-full bg-primary/10 px-2 py-0.5 text-[11px] font-medium text-primary ${className ?? ''}`}
        data-testid="ai-generated-badge"
      >
        <AppIcon name="Sparkles" size={12} aria-hidden="true" />
        {t('ai.generated')}
        <span className="sr-only">{hint ?? t('ai.generatedHint')}</span>
      </span>
    </Tooltip>
  );
};

export default AiGeneratedBadge;
